import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { spinnerOpen } from '../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import Button, {BUTTON_STYLE, BUTTON_TYPE} from '../Button/Button';
import { redirectFlowAction } from '../../framework/store/RedirectFlow/RedirectFlowActions';
import _ from 'lodash';

// This button will allow itself to only be pushed once, then will disable the
// button and show the spinner
export class RedirectButton extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,

        // Passed in props
        buttonId: PropTypes.string,
        buttonType: PropTypes.oneOf(Object.values(BUTTON_TYPE)),
        className: PropTypes.string,
        ctaLabel: PropTypes.string.isRequired,
        actionUri: PropTypes.string.isRequired

    };
    
    static defaultProps = {
        buttonType: BUTTON_TYPE.SUBMIT,
        className: ''
    };

    constructor() {
        super();
        this.state = { submitted: false };
    }


    handleSubmit = () => {
        const { actionUri } = this.props;
        this.setState({ submitted: true });
        this.props.onSubmit(actionUri);
    };

    render() {
        const { buttonId, buttonType, className, ctaLabel } = this.props;

        return (
            <Button
                data-automation-id="continue"
                btnType={buttonType}
                className={className}
                btnStyle={BUTTON_STYLE.PP_PRIMARY}
                disabled={this.state.submitted}
                id={buttonId}
                onClick={this.handleSubmit}
            >{ctaLabel}</Button>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    onSubmit(actionUri) {
        dispatch(spinnerOpen());
        dispatch(redirectFlowAction(actionUri));
    }
});

export default connect(null, mapDispatchToProps)(RedirectButton);
